import fill from 'lodash-es/fill';

export namespace GridUtils {
  export type Coordinates = {
    left: number;
    top: number;
    width: number;
    imageHeight: number;
    height: number;
  };

  type Inputs = {
    fixedRatio: false | number;
    availableWidth: number;
    ratioList: Array<number>;
    additionalHeights: Array<number>;
    minColNum: number;
    idealColWidth: number;
    spaceBetween: number;
    spaceAround: [number, number, number, number];
    getInitialColums?: (numOfCol: number, colSize: number) => Array<number>;
  };

  export type GridResult = {
    coords: Array<Coordinates>;
    height: number;
    verticalOrigin: number;
    horizontalOrigin: number;
    getWidth: (val: number) => number;
    colSize: number;
    numOfCol: number;
  };

  export const getGrid = ({
    fixedRatio,
    availableWidth,
    ratioList,
    additionalHeights,
    minColNum,
    idealColWidth,
    spaceBetween,
    spaceAround,
    getInitialColums,
  }: Inputs): GridResult => {
    const [st, sr, sb, sl] = spaceAround;
    const contentWidth = availableWidth - (sl + sr);
    const numOfCol = Math.max(minColNum, Math.floor(contentWidth / idealColWidth));
    const colSize = Math.floor((contentWidth - spaceBetween * (numOfCol - 1)) / numOfCol);
    const contentWidthExact = colSize * numOfCol + spaceBetween * (numOfCol - 1);
    const rest = contentWidth - contentWidthExact;
    const leftAdd = Math.floor(rest / 2);

    // compute positions
    let cols: Array<number> = getInitialColums
      ? getInitialColums(numOfCol, colSize).map(v => v + st)
      : fill(Array(numOfCol), st);

    if (fixedRatio) {
      cols = cols.map(col => {
        if (col === 0) {
          return 0;
        }
        const ratioCount = Math.round(fixedRatio / (colSize / col));
        return Math.floor(colSize / fixedRatio * ratioCount + spaceBetween * (ratioCount - 1)) + spaceBetween;
      });
    }

    const coords = ratioList.map((ratio, index) => {
      const colIndex = cols.indexOf(Math.min(...cols));
      const addHeight = additionalHeights[index] || 0;
      let imageHeight = Math.floor(colSize / ratio);
      if (fixedRatio) {
        const ratioCount = Math.max(1, Math.round(fixedRatio / ratio));
        imageHeight = Math.floor(colSize / fixedRatio * ratioCount + spaceBetween * (ratioCount - 1));
      }
      const height = imageHeight + addHeight;
      const coord: Coordinates = {
        width: colSize,
        height,
        imageHeight,
        left: sl + leftAdd + colIndex * (colSize + spaceBetween),
        top: cols[colIndex],
      };
      cols[colIndex] = cols[colIndex] + height + spaceBetween;
      return coord;
    });

    const verticalOrigin = 0;
    const horizontalOrigin = sl + leftAdd;
    const getWidth = (val: number) => colSize + (colSize + spaceBetween) * (val - 1);

    const totalHeight = Math.max(...cols) + sb - spaceBetween;

    return {
      coords,
      height: totalHeight,
      verticalOrigin,
      horizontalOrigin,
      getWidth,
      colSize,
      numOfCol,
    };
  };
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/GridUtils.ts